import React from 'react'
import PropTypes from 'prop-types'
import { intl } from 'lang/intl'

import { Toggle } from '../../../../components'
import { WebinarPanelComponent } from '../index'
import { useUpdateQuestionModeMutation } from '../../../../../global/blocs/useLiveData'

import './WebinarSidebarQuestionsPanelComponent.scss'

const WebinarSidebarQuestionsPanelComponent = (props) => {
  const { children, isQuestionsEnabled, isShowingPermissionToggle } = props

  const { mutateAsync: updateQuestionMode } = useUpdateQuestionModeMutation()

  const toggleLabel = intl.formatMessage({
    defaultMessage: 'Audience can ask questions',
  })

  return (
    <>
      {isShowingPermissionToggle && (
        <WebinarPanelComponent>
          <div className="questions-mode-toggle-wrapper">
            <span>{toggleLabel}</span>
            <Toggle
              onChange={updateQuestionMode}
              toggled={isQuestionsEnabled}
              ariaLabel={toggleLabel}
            />
          </div>
        </WebinarPanelComponent>
      )}
      <div className="questions-wrapper">{children}</div>
    </>
  )
}

WebinarSidebarQuestionsPanelComponent.propTypes = {
  isQuestionsEnabled: PropTypes.bool,
  children: PropTypes.node,
  isShowingPermissionToggle: PropTypes.bool,
}

WebinarSidebarQuestionsPanelComponent.defaultProps = {
  isShowingPermissionToggle: false,
}

export default WebinarSidebarQuestionsPanelComponent
